import { render } from "./resetpassword.vue?vue&type=template&id=6f3666a9&scoped=true"
import script from "./resetpassword.vue?vue&type=script&lang=js"
export * from "./resetpassword.vue?vue&type=script&lang=js"

import "./resetpassword.vue?vue&type=style&index=0&id=6f3666a9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f3666a9"

export default script